import React from "react"
import Chart from "react-apexcharts"
import style from "./style.module.scss"
import { useTheme } from "@material-ui/core/styles"
import { useRouteMatch } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import config from "../../../config"
import { useChartStyles } from "../utils"

export default function ColumnCharts({ seriesClauses, seriesSentences, seriesWords, categories }) {
  const { params: { type } } = useRouteMatch()
  const { theme: { bgColors, colors } } = useTheme()
  const { t } = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const isDark = themeState === config.THEMES_MODES.CONTRAST_DARK
  const textsColors = [colors.colorProgress120, colors.colorProgress60]
  const firstChartColor = isContrast ? colors.colorProgress120 : '#7798bd'
  const secondChartColor = isContrast ? colors.colorProgress120 : '#69499d'
  const thirdChartColor = isContrast ? colors.colorProgress120 : '#9d499a'
  useChartStyles(bgColors, colors)()

  const optionsClauses = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    legend: {
      labels: {
        colors: colors.colorText,
      }
    },
    xaxis: {
      categories: Object.keys(categories.clauses),
      labels: {
      style: { colors: colors.colorText },
    }
    },
    yaxis: {
      labels: {
        style: { colors: colors.colorText }, 
        formatter: function (y) {
          return y.toFixed(0) + "%"
        }
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " %"
        }
      },
      theme: isDark ? 'dark' : 'light'
    },
  }
  const optionsSentences = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    legend: {
      labels: {
        colors: colors.colorText,
      }
    },
    xaxis: {
      categories: Object.keys(categories.sentences),
      labels: {
      style: { colors: colors.colorText },
    }
    },
    yaxis: {
      labels: {
        style: { colors: colors.colorText },
        formatter: function (y) {
          return y.toFixed(0) + "%"
        }
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " %"
        },
        theme: isDark ? 'dark' : 'light'
      }
    }
  }
  const optionsWords = {
    chart: {
      type: 'bar',
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '40%',
        endingShape: 'rounded'
      },
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      categories: Object.keys(categories.words),
      labels: {
      style: { colors: colors.colorText },
    }
    },
    yaxis: {
      labels: {
        style: { colors: colors.colorText },
        formatter: function (y) {
          return y.toFixed(0) + "%"
        }
      }
    },
    fill: {
      opacity: 1
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " %"
        },
      },
      theme: isDark ? 'dark' : 'light',
    }
  }


  return (
    <div className={`${style.charts} ${style.cells}`} style={{ backgroundColor: bgColors.bgPrimary0 }}>
      <div style={{ color: colors.colorText }}>
        <h2>{t("CLAUSES LENGTH")}</h2>
        <Chart options={{ colors: type !== "texts" ? [firstChartColor] : textsColors, ...optionsClauses }} series={seriesClauses} type="bar" height={350} />
      </div>
      <div style={{ color: colors.colorText }}>
        <h2>{t("SENTENCES LENGTH")}</h2>
        <Chart options={{ colors: type !== "texts" ? [secondChartColor] : textsColors, ...optionsSentences }} series={seriesSentences} type="bar" height={350} />
      </div>
      <div style={{ color: colors.colorText }}>
        <h2>{t("WORDS LENGTH")}</h2>
        <Chart options={{ colors: type !== "texts" ? [thirdChartColor] : textsColors, ...optionsWords }} series={seriesWords} type="bar" height={350} />
      </div>
    </div>
  )
}
